import React, { ElementType, MouseEventHandler } from 'react'
import { ReactNode } from 'react'
import { Avatar as MUIAvatar, SxProps } from '@mui/material'

export interface AvatarProps {
  alt?: string
  bgcolor?: string
  children?: ReactNode
  className?: string
  component?: ElementType<any>
  onClick?: (() => void) | MouseEventHandler<HTMLElement>
  onMouseDown?: (() => void) | MouseEventHandler<HTMLElement>
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge'
  sizes?: string
  src?: string
  sx?: SxProps
  variant?: 'circular' | 'rounded' | 'square'
}

export const AVATAR_SMALL_SIZE = 24
export const AVATAR_MEDIUM_SIZE = 32
export const AVATAR_LARGE_SIZE = 48
export const AVATAR_XLARGE_SIZE = 96

export const getAvatarSize = (value: AvatarProps['size']) => {
  switch (value) {
  case 'xlarge': {
    return {
      height: 96,
      width: 96,
      fontSize: 'h3.fontSize',
      fontWeight: 'bold'
    }
  }
  case 'large': {
    return {
      height: 48,
      width: 48,
      fontSize: 'h5.fontSize',
      fontWeight: 'bold'
    }
  }
  case 'small': {
    return {
      height: 20,
      width: 20,
      fontSize: 'body2.fontSize',
      fontWeight: 'bold'
    }
  }
  case 'xsmall': {
    return {
      height: 18,
      width: 18,
      fontSize: 'body2.fontSize',
      fontWeight: 'bold'
    }
  }
  // 'medium'
  default: {
    return {
      height: 32,
      width: 32,
      fontSize: 'body1.fontSize',
      fontWeight: 'bold'
    }
  }
  }
}

/**
 * An avatar displays an image, icon or initials
 * (most often) representing a user.
 */

const Avatar = React.forwardRef((props: AvatarProps, ref: any) => {
  const { bgcolor, size, sx, ...rest } = props

  return (
    <MUIAvatar
      sx={{
        bgcolor: bgcolor ?? 'grey.100',
        color: 'text.secondary',
        ...getAvatarSize(size),
        ...sx
      }}
      {...rest}
      ref={ref}
    >
      {props.alt && !props.children ? props.alt.charAt(0) : props.children}
    </MUIAvatar>
  )
})

Avatar.displayName = 'Avatar'
export default Avatar
